import React, { useState, useEffect } from 'react'
import { Link, useParams, Redirect } from 'react-router-dom'
import Layout from '../../components/Layout'
import config from '../../config'
import {
    getNativeAd,
    updateNativeAd,
    deleteNativeAd,
} from '../../api/nativeads'
import DateTimePicker from 'react-datetime-picker'
import { TwitterPicker } from 'react-color'
import UnsplashBrowser from '../../components/UnsplashBrowser'
import MobileAdAnalytics from '../../components/MobileAdAnalytics'

const NativeAd = (props) => {
    /**
     * Default colors to use with twitter picker
     */
    const defaultColors = [
        '#FFFFFF',
        '#FF6900',
        '#FCB900',
        '#00D084',
        '#8ED1FC',
        '#0693E3',
        '#ABB8C3',
        '#EB144C',
        '#F78DA7',
        '#9900EF',
    ]

    let { id: siteId } = useParams()
    const [site, setSite] = useState({})
    const adId = props.match.params.adId
    const [ad, setAd] = useState({})
    const [nativeAd, setNativeAd] = useState({
        title: '',
        description: '',
        button_text: '',
        button_background_color: '#48BB78',
        button_text_color: '#ffffff',
        background_image: '',
        link: '',
        link_type: 'https://',
    })
    const [showTextColorPicker, setShowTextColorPicker] = useState(false)
    const [showButtonColorPicker, setShowButtonColorPicker] = useState(false)
    const [isUpdating, setIsUpdating] = useState(false)
    const [toNativeAds, setToNativeAds] = useState(false)
    const [showUnsplashBrowswer, setShowUnsplashBrowser] = useState(false)
    const [currentTab, setCurrentTab] = useState('designer')

    /**
     * Load initial data
     */
    useEffect(() => {
        getSite(siteId)
        fetchAd(adId)
    }, [site])

    /**
     * Fetch ads by location
     */
    const fetchAd = async (id) => {
        try {
            const ad = await getNativeAd(id)
            setAd(ad.data)
            console.log(ad.data)
            setNativeAd({ ...nativeAd, ...ad.data.ad })
        } catch (err) {
            alert(
                'Error, something went wrong. Please refresh and try again. Error #nativeads-get'
            )
            console.log(err)
        }
    }

    /**
     * Sets site object state based off url param (id)
     */
    const getSite = (siteId) => {
        config.sites.find((site) => {
            if (site.value === siteId) {
                setSite(site)
            }
        })
    }

    const validateInputs = () => {
        /**
         * Validate that there aren't any empty inputs
         * This is horribly ugly, don't judge me it needed to be done quick
         */
        if (
            ad.title === '' ||
            nativeAd.link === '' ||
            nativeAd.link_type === '' ||
            nativeAd.title === '' ||
            nativeAd.button_text === '' ||
            nativeAd.description === '' ||
            nativeAd.background_image === '' ||
            nativeAd.button_text_color === '' ||
            nativeAd.button_background_color === ''
        ) {
            alert('There are empty values. Make sure all inputs have a value')
        } else {
            updateAd()
        }
    }

    const updateAd = async () => {
        try {
            setIsUpdating(true)
            let updated_ad = {
                ...ad,
                ad: {
                    ...nativeAd,
                },
            }
            let updatedAd = await updateNativeAd(updated_ad)
            setIsUpdating(false)
            return updatedAd
        } catch (err) {
            alert('Error saving ad')
            console.log(err)
        }
    }

    const archiveAd = async (new_status) => {
        try {
            await updateNativeAd({
                ...ad,
                status: new_status,
            })
            setToNativeAds(true)
        } catch (err) {
            console.log(err)
            alert(
                'Error - something went wrong archiving the ad. Please try again.'
            )
        }
    }

    const deleteAd = (ad) => {
        let answer = window.confirm('Are you sure you want to delete this?')
        if (answer === true) {
            deleteNativeAd(ad).then((data) => {
                console.log('deleted')
                console.log(data)
                setToNativeAds(true)
            })
        }
    }

    if (toNativeAds) {
        return <Redirect to={`/dashboard/${siteId}/nativeads`} />
    }

    return (
        <Layout>
            <div>
                {ad.status === 'archived' && (
                    <div className="bg-orange-200 text-orange-900 text-center p-6 rounded-lg shadow mb-8">
                        <span className="font-bold">This ad is archived. </span>
                        To make changes, click 'Un-Arhchive' under 'Actions'.
                    </div>
                )}

                <div>
                    <div className="mb-12">
                        <div className="flex flex-row">
                            <button
                                onClick={() => setCurrentTab('designer')}
                                className={`px-4 py-2 rounded mr-3 outline-none focus:outline-none flex flex-row transition duration-150 ease-in-out ${
                                    currentTab === 'designer'
                                        ? 'bg-blue-500 text-white shadow'
                                        : 'bg-gray-400 text-gray-800 shadow-inner'
                                }`}
                            >
                                <span className="mr-2">
                                    <svg
                                        className="w-5 h-5 opacity-75"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        height="24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        fill="none"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
                                    </svg>
                                </span>
                                Designer
                            </button>
                            <button
                                onClick={() => setCurrentTab('analytics')}
                                className={`px-4 py-2 rounded mr-3 outline-none focus:outline-none flex flex-row transition duration-150 ease-in-out ${
                                    currentTab === 'analytics'
                                        ? 'bg-blue-500 text-white shadow'
                                        : 'bg-gray-400 text-gray-800 shadow-inner'
                                }`}
                            >
                                <span className="mr-2">
                                    <svg
                                        className="w-5 h-5 opacity-75"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        height="24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        fill="none"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <line
                                            x1="18"
                                            y1="20"
                                            x2="18"
                                            y2="10"
                                        ></line>
                                        <line
                                            x1="12"
                                            y1="20"
                                            x2="12"
                                            y2="4"
                                        ></line>
                                        <line
                                            x1="6"
                                            y1="20"
                                            x2="6"
                                            y2="14"
                                        ></line>
                                    </svg>
                                </span>
                                Analytics
                            </button>
                        </div>
                    </div>
                    <div>
                        {currentTab === 'designer' && (
                            <div>
                                <div className="mb-2 flex justify-between">
                                    <div className="text-3xl font-semibold h-12">
                                        {ad.title}
                                    </div>
                                    <div className="flex flex-row items-center">
                                        <a
                                            className="border-2 border-blue-500 bg-blue-500 hover:bg-blue-600 hover:border-blue-600 text-white px-3 rounded cursor-pointer text-center py-1 shadow outline-none mr-2"
                                            href={`/.netlify/functions/native-ad-preview?ad_id=${ad.id}`}
                                            target="_blank"
                                        >
                                            Share Public Preview
                                        </a>
                                        <div>
                                            {ad.status !== 'archived' && (
                                                <button
                                                    onClick={() =>
                                                        validateInputs()
                                                    }
                                                    className="border-2 border-green-500 bg-green-500 hover:bg-green-600 hover:border-green-600 text-white px-3 rounded cursor-pointer text-center py-1 shadow outline-none"
                                                >
                                                    {isUpdating
                                                        ? 'Saving...'
                                                        : 'Save'}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-wrap mb-12 relative">
                                    <div className="w-full md:w-2/5">
                                        <div className="flex flex-col mb-6">
                                            <label className="uppercase text-sm tracking-wide font-semibold text-gray-700 ml-2 mb-px">
                                                Title
                                            </label>
                                            <input
                                                name="title"
                                                value={ad.title}
                                                placeholder="Title"
                                                onChange={(e) =>
                                                    setAd({
                                                        ...ad,
                                                        title: e.target.value,
                                                    })
                                                }
                                                className="border-2 border-gray-300 focus:border-blue-500 px-3 py-2 rounded-lg outline-none"
                                            />
                                        </div>
                                        <div className="flex flex-col mb-6">
                                            <label className="uppercase text-sm tracking-wide font-semibold text-gray-700 ml-2 mb-px">
                                                Start Date
                                            </label>
                                            <DateTimePicker
                                                className="inline-block bg-white border-2 border-gray-300 focus:border-blue-500 px-3 py-2 rounded-lg outline-none"
                                                onChange={(e) =>
                                                    setAd({
                                                        ...ad,
                                                        start_date: e,
                                                    })
                                                }
                                                value={
                                                    ad.start_date
                                                        ? new Date(
                                                              ad.start_date
                                                          )
                                                        : new Date()
                                                }
                                            />
                                        </div>
                                        <div className="flex flex-col mb-6">
                                            <label className="uppercase text-sm tracking-wide font-semibold text-gray-700 ml-2 mb-px">
                                                End Date
                                            </label>
                                            <DateTimePicker
                                                className="inline-block bg-white border-2 border-gray-300 focus:border-blue-500 px-3 py-2 rounded-lg outline-none"
                                                onChange={(e) =>
                                                    setAd({
                                                        ...ad,
                                                        end_date: e,
                                                    })
                                                }
                                                value={
                                                    ad.end_date
                                                        ? new Date(ad.end_date)
                                                        : new Date()
                                                }
                                            />
                                        </div>
                                        <div className="flex flex-col mb-6">
                                            <label className="uppercase text-sm tracking-wide font-semibold text-gray-700 ml-2 mb-px">
                                                Status
                                            </label>
                                            <select
                                                value={ad.status}
                                                onChange={(e) =>
                                                    setAd({
                                                        ...ad,
                                                        status: e.target.value,
                                                    })
                                                }
                                                className="px-3 py-2 border-2 border-gray-300 rounded-lg"
                                            >
                                                <option value="active">
                                                    Active
                                                </option>
                                                <option value="pending">
                                                    Pending
                                                </option>
                                            </select>
                                        </div>
                                        <div className="text-2xl font-semibold mt-12">
                                            Design
                                        </div>
                                        <p className="text-sm italic text-gray-800 antialiased mb-4">
                                            To the right is a preview. A native
                                            ad does NOT have dimensions, so it
                                            will fit perfectly for any device.
                                        </p>
                                        <div className="flex flex-col mb-6">
                                            <label className="uppercase text-sm tracking-wide font-semibold text-gray-700 ml-2 mb-px">
                                                Ad Title
                                            </label>
                                            <input
                                                name="title"
                                                value={nativeAd.title}
                                                placeholder="Ad Title"
                                                onChange={(e) =>
                                                    setNativeAd({
                                                        ...nativeAd,
                                                        title: e.target.value,
                                                    })
                                                }
                                                className="border-2 border-gray-300 focus:border-blue-500 px-3 py-2 rounded-lg outline-none"
                                            />
                                        </div>
                                        <div className="flex flex-col mb-6">
                                            <label className="uppercase text-sm tracking-wide font-semibold text-gray-700 ml-2 mb-px">
                                                Ad Description
                                            </label>
                                            <input
                                                name="description"
                                                value={nativeAd.description}
                                                placeholder="Ad description"
                                                onChange={(e) =>
                                                    setNativeAd({
                                                        ...nativeAd,
                                                        description:
                                                            e.target.value,
                                                    })
                                                }
                                                className="border-2 border-gray-300 focus:border-blue-500 px-3 py-2 rounded-lg outline-none"
                                            />
                                        </div>
                                        <div className="flex flex-col mb-6">
                                            <label className="uppercase text-sm tracking-wide font-semibold text-gray-700 ml-2 mb-px">
                                                Ad Button Text
                                            </label>
                                            <input
                                                name="button_text"
                                                value={nativeAd.button_text}
                                                placeholder="Ad description"
                                                onChange={(e) =>
                                                    setNativeAd({
                                                        ...nativeAd,
                                                        button_text:
                                                            e.target.value,
                                                    })
                                                }
                                                className="border-2 border-gray-300 focus:border-blue-500 px-3 py-2 rounded-lg outline-none"
                                            />
                                        </div>
                                        <div className="flex flex-row justify-between">
                                            <div className="flex flex-col mb-6">
                                                <label className="uppercase text-sm tracking-wide font-semibold text-gray-700 ml-2 mb-px">
                                                    Button Text Color
                                                </label>
                                                <button
                                                    className="mx-auto h-16 w-16 rounded-full rounded block shadow-xl"
                                                    onClick={() =>
                                                        setShowTextColorPicker(
                                                            true
                                                        )
                                                    }
                                                    style={{
                                                        backgroundColor:
                                                            nativeAd.button_text_color,
                                                    }}
                                                ></button>
                                                <div className="relative">
                                                    {showTextColorPicker ? (
                                                        <div className="absolute z-20">
                                                            <div
                                                                onClick={() =>
                                                                    setShowTextColorPicker(
                                                                        false
                                                                    )
                                                                }
                                                                className="fixed top-0 left-0 right-0 bottom-0"
                                                            ></div>
                                                            <TwitterPicker
                                                                colors={
                                                                    defaultColors
                                                                }
                                                                onChange={(
                                                                    color
                                                                ) =>
                                                                    setNativeAd(
                                                                        {
                                                                            ...nativeAd,
                                                                            button_text_color:
                                                                                color.hex,
                                                                        }
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>

                                            <div className="flex flex-col mb-6">
                                                <label className="uppercase text-sm tracking-wide font-semibold text-gray-700 ml-2 mb-px">
                                                    Button Background Color
                                                </label>
                                                <button
                                                    className="mx-auto h-16 w-16 rounded-full rounded block shadow-xl"
                                                    onClick={() =>
                                                        setShowButtonColorPicker(
                                                            true
                                                        )
                                                    }
                                                    style={{
                                                        backgroundColor:
                                                            nativeAd.button_background_color,
                                                    }}
                                                ></button>
                                                <div className="relative">
                                                    {showButtonColorPicker ? (
                                                        <div className="absolute z-20">
                                                            <div
                                                                onClick={() =>
                                                                    setShowButtonColorPicker(
                                                                        false
                                                                    )
                                                                }
                                                                className="fixed top-0 left-0 right-0 bottom-0"
                                                            ></div>
                                                            <TwitterPicker
                                                                colors={
                                                                    defaultColors
                                                                }
                                                                onChange={(
                                                                    color
                                                                ) =>
                                                                    setNativeAd(
                                                                        {
                                                                            ...nativeAd,
                                                                            button_background_color:
                                                                                color.hex,
                                                                        }
                                                                    )
                                                                }
                                                            />
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-col mb-6">
                                            <label className="uppercase text-sm tracking-wide font-semibold text-gray-700 ml-2 mb-px">
                                                Ad Background Image
                                            </label>
                                            <input
                                                disabled
                                                name="background_image"
                                                value={
                                                    nativeAd.background_image
                                                }
                                                placeholder="Ad background image"
                                                onChange={(e) =>
                                                    setNativeAd({
                                                        ...nativeAd,
                                                        background_image:
                                                            e.target.value,
                                                    })
                                                }
                                                className="border-2 border-gray-300 focus:border-blue-500 px-3 py-2 rounded-lg outline-none mb-2"
                                            />
                                            <button
                                                onClick={() =>
                                                    setShowUnsplashBrowser(true)
                                                }
                                                className="text-blue-400 hover:underline text-justify pl-2 mb-2"
                                            >
                                                Browse Images
                                            </button>
                                        </div>
                                        <div
                                            className={`${
                                                showUnsplashBrowswer
                                                    ? 'block'
                                                    : 'hidden'
                                            }`}
                                        >
                                            <div className="w-screen h-screen bg-black bg-opacity-25 fixed top-0 left-0 z-10 overflow-y-scroll">
                                                <UnsplashBrowser
                                                    selectImage={(image_url) =>
                                                        setNativeAd({
                                                            ...nativeAd,
                                                            background_image: image_url,
                                                        })
                                                    }
                                                    closeUnsplash={() =>
                                                        setShowUnsplashBrowser(
                                                            false
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="flex flex-col mb-6">
                                            <label className="uppercase text-sm tracking-wide font-semibold text-gray-700 ml-2 mb-px">
                                                Ad Link Type
                                            </label>
                                            <select
                                                value={nativeAd.link_type}
                                                onChange={(e) =>
                                                    setNativeAd({
                                                        ...nativeAd,
                                                        link_type:
                                                            e.target.value,
                                                    })
                                                }
                                                className="px-3 py-2 border-2 border-gray-300 rounded-lg"
                                            >
                                                <option value="https://">
                                                    Web Link
                                                </option>
                                                <option value="mailto:">
                                                    Email
                                                </option>
                                                <option value="tel:">
                                                    Phone
                                                </option>
                                            </select>
                                        </div>
                                        <div className="flex flex-col mb-6">
                                            <label className="uppercase text-sm tracking-wide font-semibold text-gray-700 ml-2 mb-px">
                                                Ad Link
                                            </label>
                                            <div className="flex flex-row items-center border-2 border-gray-300 rounded-lg px-3 py-2 bg-white">
                                                <div className="mr-px text-gray-700">
                                                    {nativeAd.link_type}
                                                </div>
                                                <input
                                                    name="link"
                                                    value={nativeAd.link}
                                                    placeholder={
                                                        nativeAd.link_type ===
                                                        'https://'
                                                            ? 'eagleradio.net'
                                                            : nativeAd.link_type ===
                                                              'mailto:'
                                                            ? 'gbland@eagleradio.net'
                                                            : '785-658-1234'
                                                    }
                                                    onChange={(e) =>
                                                        setNativeAd({
                                                            ...nativeAd,
                                                            link:
                                                                e.target.value,
                                                        })
                                                    }
                                                    className="flex-1  focus:border-blue-500 rounded-lg outline-none"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-1 relative">
                                        <div
                                            className="sticky top-0 bg-gray-200 rounded w-full md:w-3/4 mx-auto flex flex-col justify-end relative bg-cover bg-center mt-6"
                                            style={{
                                                height: '400px',
                                                maxWidth: '500px',
                                                backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8)),url(${nativeAd.background_image})`,
                                            }}
                                        >
                                            <div className="p-6">
                                                <div className="text-2xl leading-tight text-white font-semibold">
                                                    {nativeAd.title}
                                                </div>
                                                <div
                                                    className="text-md mb-3 text-white"
                                                    style={{ opacity: 0.85 }}
                                                >
                                                    {nativeAd.description}
                                                </div>
                                                {nativeAd.button_text && (
                                                    <div
                                                        className="bg-green-500 text-white text-center py-3 px-2 overflow-x-hidden rounded whitespace-no-wrap"
                                                        style={{
                                                            backgroundColor:
                                                                nativeAd.button_background_color,
                                                            color:
                                                                nativeAd.button_text_color,
                                                        }}
                                                    >
                                                        {nativeAd.button_text}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-2 flex justify-between">
                                    <div className="text-3xl font-semibold h-12">
                                        Actions
                                    </div>
                                </div>
                                {ad.status !== 'archived' && (
                                    <div className="mb-8">
                                        <button
                                            onClick={() =>
                                                archiveAd('archived')
                                            }
                                            className="mb-1 flex flex-row items-center border-2 border-orange-500 bg-orange-500 hover:bg-orange-600 hover:border-orange-600 text-white px-3 rounded cursor-pointer text-center py-1 shadow outline-none"
                                        >
                                            <span>
                                                <svg
                                                    className="w-5 h-5 pr-1"
                                                    viewBox="0 0 24 24"
                                                    width="24"
                                                    height="24"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    fill="none"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                >
                                                    <polyline points="21 8 21 21 3 21 3 8"></polyline>
                                                    <rect
                                                        x="1"
                                                        y="3"
                                                        width="22"
                                                        height="5"
                                                    ></rect>
                                                    <line
                                                        x1="10"
                                                        y1="12"
                                                        x2="14"
                                                        y2="12"
                                                    ></line>
                                                </svg>
                                            </span>
                                            Archive
                                        </button>
                                        <p className="text-sm italic text-gray-800 antialiased max-w-md">
                                            Archiving an ad will not delete the
                                            ad. It just means it that the
                                            campaign is complete or the client
                                            is no longer paying. This is
                                            reversable, and is meant to keep the
                                            ad list a little less cluttered.
                                        </p>
                                    </div>
                                )}
                                {ad.status === 'archived' && (
                                    <div className="mb-8">
                                        <button
                                            onClick={() => archiveAd('active')}
                                            className="mb-1 flex flex-row items-center border-2 border-orange-500 bg-orange-500 hover:bg-orange-600 hover:border-orange-600 text-white px-3 rounded cursor-pointer text-center py-1 shadow outline-none"
                                        >
                                            <span>
                                                <svg
                                                    className="w-5 h-5 pr-1"
                                                    viewBox="0 0 24 24"
                                                    width="24"
                                                    height="24"
                                                    stroke="currentColor"
                                                    strokeWidth="2"
                                                    fill="none"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                >
                                                    <polyline points="21 8 21 21 3 21 3 8"></polyline>
                                                    <rect
                                                        x="1"
                                                        y="3"
                                                        width="22"
                                                        height="5"
                                                    ></rect>
                                                    <line
                                                        x1="10"
                                                        y1="12"
                                                        x2="14"
                                                        y2="12"
                                                    ></line>
                                                </svg>
                                            </span>
                                            Un-Archive
                                        </button>
                                        <p className="text-sm italic text-gray-800 antialiased max-w-md">
                                            Taking this ad out of archive will
                                            allow changes and to continue the ad
                                            campaign.
                                        </p>
                                    </div>
                                )}
                                <div className="mb-24">
                                    <button
                                        onClick={() => deleteAd(ad)}
                                        className="mb-1 flex flex-row items-center border-2 border-red-600 bg-red-600 hover:bg-red-700 hover:border-red-700 text-white px-3 rounded cursor-pointer text-center py-1 shadow outline-none"
                                    >
                                        <span>
                                            <svg
                                                className="w-5 h-5 pr-1"
                                                viewBox="0 0 24 24"
                                                width="24"
                                                height="24"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <polyline points="3 6 5 6 21 6"></polyline>
                                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                                <line
                                                    x1="10"
                                                    y1="11"
                                                    x2="10"
                                                    y2="17"
                                                ></line>
                                                <line
                                                    x1="14"
                                                    y1="11"
                                                    x2="14"
                                                    y2="17"
                                                ></line>
                                            </svg>
                                        </span>
                                        Delete
                                    </button>
                                    <p className="text-sm italic text-gray-800 antialiased max-w-md">
                                        This is permanent and you won't be able
                                        to go back and look at analytics.
                                    </p>
                                </div>
                            </div>
                        )}
                        <div
                            className={`${
                                currentTab === 'analytics' ? 'block' : 'hidden'
                            }`}
                        >
                            {ad.id && (
                                <MobileAdAnalytics adId={ad.id} site={site} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default NativeAd
